import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import LuProcessInputTypeAppResource from './LuProcessInputTypeAppResource';
import ProcessAppResource from './ProcessAppResource';
import ProcessInputCategoryAppResource from './ProcessInputCategoryAppResource';
import ProcessInstanceInputAppResource from './ProcessInstanceInputAppResource';
import ProcessOutputAppResource from './ProcessOutputAppResource';

export const TYPE_ADDRESS = 'address';
export const TYPE_CURRENCY = 'currency';

export const TYPES = {
    TYPE_ADDRESS,
    TYPE_CURRENCY,
}

class ProcessInputAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'process-input';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'processes/inputs';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'inputTypeId',
            'processUuid',
            'categoryUuid',
            'title',
            'content',
            'meta',
            'info',
            'sort',
            'inputType',
            'category',
            'process',
            'processInstanceInputs',
            'processOutputs',
            'conditionInput',
            'conditionInputs',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            inputType: LuProcessInputTypeAppResource,
            category: ProcessInputCategoryAppResource,
            process: ProcessAppResource,
            conditionInput: ProcessInputAppResource,
            conditionInputs: ProcessInputAppResource,
            processInstanceInputs: ProcessInstanceInputAppResource,
            processOutputs: ProcessOutputAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            inputType: 'input_type_id',
            category: 'category_uuid',
            process: 'process_uuid',
            conditionInput: 'condition_input_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            inputTypeId: {
                numericality: true,
                presence: true,
            },
            processUuid: {
                type: 'string',
                presence: true,
            },
            categoryUuid: {
                type: 'string',
                presence: true,
            },
            conditionInputUuid: {
                type: 'string',
            },
            content: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            sort: {
                numericality: true,
            },
            meta: {
                array: {
                    items: {
                        type: 'string',
                    },
                },
            },
        };
    }

}

export default ProcessInputAppResource;
